// import { upload } from '@/request/ecard'
import { getProvince } from '@/utils/cardutil'

const state = {
  // photo1: '',
  // photo2: '',
  // photo3: '',
  // photo4: '',
  showLimit: false,
  orderId: '',
  type: '',
  province: '',
  num: '',
  result: 0,
  cardNo: '',
  compNo: '',
  parentMobile: '',
  compName: '',
  invoiceType: 1,
  billType: 1,
  title: '',
  taxNo: '',
  compAddr: '',
  compPhone: '',
  taxDate: '',
  bankName: '',
  bankAccount: '',
  name: '',
  identifyType: '',
  identifyNo: '',
  mobile: '',
  phoneNo: '',
  areaNo: '',
  areaText: '',
  carNo: '',
  limitArea: '',
  station: '',
  oilName: '',
  dayOfMoney: '',
  dayOfCount: '',
  countOfNum: '',
  nodeAddress: '',
  nodeTel: '',
  list: [],
  invitation: {}
}

const mutations = {
  SET_INVITATION(state, invitation) {
    state.invitation = invitation
  },
  SET_TYPE(state, type) {
    state.type = type
  },
  SET_INVOICE_TYPE(state, invoiceType) {
    state.invoiceType = invoiceType
    if (invoiceType === 2) {
      state.billType = 1
    }
  },
  SET_BILL_TYPE(state, billType) {
    state.billType = billType
  },
  SET_CARD_NO(state, cardNo) {
    state.cardNo = cardNo
  },
  SET_MAIN_CARD(state, { name, identifyType, identifyNo, mobile, phoneNo, areaNo, areaText }) {
    state.name = name
    state.identifyType = identifyType
    state.identifyNo = identifyNo
    state.mobile = mobile
    state.phoneNo = phoneNo
    state.areaNo = areaNo
    state.areaText = areaText

    if (areaNo.length > 2) {
      state.province = areaNo.substring(0, 2)
    }
  },
  SET_COMP_INFO(state, datas) {
    state.title = datas.compName
    state.taxNo = datas.taxNo
    state.compAddr = datas.address
    state.compPhone = datas.tel
    state.taxDate = datas.taxDate
    state.bankName = datas.bankName
    state.bankAccount = datas.bankAcct
    state.bankName = datas.bankName
    state.bankAccount = datas.bankAcct
    state.bankName = datas.bankName
    state.bankAccount = datas.bankAcct
    state.nodeAddress =  datas.cityName + '/' + datas.areaName + '/' + datas.nodeName
    state.nodeTel = datas.telAndAdd
  },
  // SET_PHOTO1(state, photo1) {
  //   state.photo1 = photo1
  // },
  // SET_PHOTO2(state, photo2) {
  //   state.photo2 = photo2
  // },
  // SET_PHOTO3(state, photo3) {
  //   state.photo3 = photo3
  // },
  // SET_PHOTO4(state, photo4) {
  //   state.photo4 = photo4
  // },
  SET_ORDER(state, { orderId, province, num }) {
    state.orderId = orderId
    state.province = province
    state.num = num
  },
  SET_RESULT(state, result) {
    state.result = result
  },
  SET_CARD_INFO(
    state,
    {
      cardNo,
      compNo,
      compName,
      title,
      name,
      identifyNo,
      identifyType,
      mobile,
      phoneNo,
      invoiceType,
      billType,
      compAddr,
      bankName,
      bankAccount,
      taxNo,
      parentMobile
    }
  ) {
    console.log(11)
    state.parentMobile = parentMobile
    state.cardNo = cardNo
    state.compNo = compNo
    state.compName = compName
    state.title = title
    state.name = name
    state.identifyNo = identifyNo
    state.identifyType = identifyType
    state.mobile = mobile
    state.phoneNo = phoneNo
    state.invoiceType = invoiceType
    state.billType = billType
    state.compAddr = compAddr
    state.bankName = bankName
    state.bankAccount = bankAccount
    state.taxNo = taxNo

    const province = getProvince(cardNo)
    if (province) {
      state.province = province
    }
  },
  SET_SHOW_LIMIT(state, showLimit) {
    state.showLimit = showLimit
  },
  REST_LIST(state) {
    state.list = []
  },
  RESET(state) {
    state.showLimit = false
    state.orderId = ''
    state.type = ''
    state.province = ''
    state.num = ''
    state.result = 0

    state.cardNo = ''
    state.compNo = ''
    state.compName = ''
    state.invoiceType = 1
    state.billType = 1
    state.title = ''
    state.taxNo = ''
    state.compAddr = ''
    state.compPhone = ''
    state.taxDate = ''
    state.bankName = ''
    state.bankAccount = ''

    state.name = ''
    state.identifyType = ''
    state.identifyNo = ''
    state.mobile = ''
    state.phoneNo = ''
    state.areaNo = ''
    state.areaText = ''
    state.carNo = ''
    state.limitArea = ''
    state.station = ''
    state.oilName = ''
    state.dayOfMoney = ''
    state.dayOfCount = ''
    state.countOfNum = ''
    state.list = []
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
